import { singleParamActionCreator } from '../../lib/singleParamActionCreator'

export const SET_CREATIVE_IDS = 'SET_CREATIVE_IDS'
export const CREATIVES_RESET = 'CREATIVES_RESET'

export const creativesReset = singleParamActionCreator(CREATIVES_RESET)
export const setCreativeIds = singleParamActionCreator(SET_CREATIVE_IDS)
